'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Grid = require('@material-ui/core/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _styles = require('@material-ui/core/styles');

var _content = require('./components/content');

var _content2 = _interopRequireDefault(_content);

var _input_mol = require('./components/input_mol');

var _input_mol2 = _interopRequireDefault(_input_mol);

var _input_file = require('./components/input_file');

var _input_file2 = _interopRequireDefault(_input_file);

var _input_form = require('./components/input_form');

var _input_form2 = _interopRequireDefault(_input_form);

var _input_pred_json = require('./components/input_pred_json');

var _input_pred_json2 = _interopRequireDefault(_input_pred_json);

var _loading = require('./components/loading');

var _loading2 = _interopRequireDefault(_loading);

var _notice = require('./components/notice');

var _notice2 = _interopRequireDefault(_notice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles() {
  return {
    root: {
      flexGrow: 1
    }
  };
};

var FullVersion = function FullVersion(_ref) {
  var classes = _ref.classes,
      editorOnly = _ref.editorOnly;
  return _react2.default.createElement(
    _Grid2.default,
    { container: true, className: classes.root, spacing: 24 },
    _react2.default.createElement(_Grid2.default, { key: 'grid-drop-space', item: true, xs: 1 }),
    _react2.default.createElement(
      _Grid2.default,
      { key: 'grid-drop-mol', item: true, xs: 4 },
      _react2.default.createElement(_input_mol2.default, null)
    ),
    _react2.default.createElement(
      _Grid2.default,
      { key: 'grid-drop-file', item: true, xs: 4 },
      _react2.default.createElement(_input_file2.default, { editorOnly: editorOnly })
    ),
    _react2.default.createElement(
      _Grid2.default,
      { key: 'grid-drop-pred-json', item: true, xs: 2 },
      _react2.default.createElement(_input_pred_json2.default, null)
    ),
    _react2.default.createElement(
      _Grid2.default,
      { key: 'grid-form-input', item: true, xs: 1 },
      _react2.default.createElement(_input_form2.default, null)
    )
  );
};

FullVersion.propTypes = {
  classes: _propTypes2.default.object.isRequired,
  editorOnly: _propTypes2.default.bool.isRequired
};

var editortext = function editortext(classes) {
  return _react2.default.createElement(
    'span',
    { className: (0, _classnames2.default)(classes.etSpan, 'txt-sv-etext') },
    '(1) Upload a spectrum file to the dashed box on the right. Valid formats: *.dx, *.jdx, *.JCAMP, *.fid, *.zip (Bruker), *.RAW (ThermoFisher), *.mz(X)ML. A 2D spectrum is NOT available. One spectrum only, not several in parallel. (2) Click the submit button'
  );
};

var EditorVersion = function EditorVersion(_ref2) {
  var classes = _ref2.classes,
      editorOnly = _ref2.editorOnly;
  return _react2.default.createElement(
    _Grid2.default,
    { container: true, className: classes.root, spacing: 24 },
    _react2.default.createElement(_Grid2.default, { key: 'grid-drop-space', item: true, xs: 1 }),
    _react2.default.createElement(
      _Grid2.default,
      { key: 'grid-drop-mol', item: true, xs: 7 },
      editortext(classes)
    ),
    _react2.default.createElement(
      _Grid2.default,
      { key: 'grid-drop-file', item: true, xs: 2 },
      _react2.default.createElement(_input_file2.default, { editorOnly: editorOnly })
    ),
    _react2.default.createElement(
      _Grid2.default,
      { key: 'grid-form-input', item: true, xs: 1 },
      _react2.default.createElement(_input_form2.default, null)
    ),
    _react2.default.createElement(_Grid2.default, { key: 'grid-drop-space', item: true, xs: 1 })
  );
};

EditorVersion.propTypes = {
  classes: _propTypes2.default.object.isRequired,
  editorOnly: _propTypes2.default.bool.isRequired
};

var Frame = function Frame(_ref3) {
  var classes = _ref3.classes,
      editorOnly = _ref3.editorOnly;
  return _react2.default.createElement(
    'div',
    null,
    editorOnly ? _react2.default.createElement(EditorVersion, { classes: classes, editorOnly: editorOnly }) : _react2.default.createElement(FullVersion, { classes: classes, editorOnly: editorOnly }),
    _react2.default.createElement(_content2.default, { editorOnly: editorOnly }),
    _react2.default.createElement(_notice2.default, null),
    _react2.default.createElement(_loading2.default, null)
  );
};

Frame.propTypes = {
  classes: _propTypes2.default.object.isRequired,
  editorOnly: _propTypes2.default.bool.isRequired
};

exports.default = (0, _styles.withStyles)(styles)(Frame);